<template>
  <div class="builder-info my-4" :class="{ 'mobile-empty': !hasColors && item.type !== 'tyres' && !(item.type === 'framesets' && specialBuilds.length) }">

    <div class="item-info px-5 mb-2" :class="{ alone: !hasColors }">
      <p class="caption mb-0">{{ item.step.title }}</p>
      <p class="headline bb-primary--text mb-0">{{ item.name }}</p>
      <p v-if="item.type === 'framesets'" class="frame-clearance text-caption mt-1 mb-0">{{ clearanceText }}</p>
    </div>

    <div v-if="hasColors" class="item-info outline-left light--border px-5">
      <p class="caption mb-1">
        Colour <span v-if="current" class="body-1 bb-primary--text">{{ finishName( current ) || 'Unkwnown' }}</span>
      </p>
      <v-item-group :value="shownIndex" mandatory @change="$emit( 'input', shown[ $event ].index )">
        <v-item v-for="( { color }, i ) in shown" :key="i" v-slot:default="{ active, toggle }">
          <Color
            tag="a"
            :value="[ color.color, color.color2 ]"
            :selected="active"
            @click="toggle"
          />
        </v-item>
      </v-item-group>
    </div>

    <div v-if="forkOptions.length > 1" class="fork-option px-5 pt-3">
      <v-select
        :value="currentFork"
        :items="forkOptions"
        label="Fork · rigid or suspension"
        outlined dense hide-details
        @change="selectFork"
      />
    </div>

    <div v-if="item.type === 'tyres'" class="tyre-width px-5 pt-3">
      <v-select
        :value="tyreWidth"
        :items="widthOptions"
        label="Tyre width · 700c / 622"
        outlined dense hide-details
        :disabled="!widthOptions.length"
        @change="$emit('width', $event)"
      />
      <p class="caption mt-1 mb-0">{{ widthStatus }}</p>
    </div>

    <div class="item-actions px-5 mt-2" :class="{ 'description-only': !(item.type === 'framesets' && specialBuilds.length) }">

      <Btn
        class="body-1 component-description"
        color="bb-primary"
        @click="$emit('description')"
        tile dark
      >
        Description
      </Btn>

      <Btn
        v-if="item.type === 'framesets' && specialBuilds.length"
        class="ml-2 body-1"
        color="warning"
        @click="$emit('special-build')"
        tile dark
      >
        Special Builds
      </Btn>

    </div>

  </div>
</template>

<script>

  import { Btn, Color } from '@/components';

  export default {
    components: { Btn, Color },
    props: {
      tyreWidth: Number,
      widthOptions: { type: Array, default: () => [] },
      widthStatus: String,
      clearanceText: String,
      color: null,
      specialBuilds: {
        type: Array,
        default: () => []
      },
      item: {
        type: Object,
        default: () => ({})
      }
    },
    computed: {
      colors() {
        return ( this.item.colors || [] )
          .map( a => a.color )
          .sort(( a, b ) => a.priority - b.priority );
      },
      current() {
        return this.colors[ this.color ];
      },
      // Framesets sold with an alternative fork list it as sibling colours
      // (FramesetColor.fork_option); swatches show one fork's finishes.
      currentFork() {
        return ( this.current && this.current.forkOption ) || '';
      },
      shown() {
        return this.colors
          .map(( color, index ) => ({ color, index }))
          .filter(({ color }) => ( color.forkOption || '' ) === this.currentFork );
      },
      shownIndex() {
        return this.shown.findIndex( a => a.index === this.color );
      },
      forkOptions() {
        const from = fork => Math.min( ...this.colors.filter( c => ( c.forkOption || '' ) === fork ).map( c => c.price || 0 ));
        const base = from( '' );
        return [ ...new Set( this.colors.map( c => c.forkOption || '' )) ].map( fork => ({
          value: fork,
          text: fork
            ? `${ fork } (+€${ ( from( fork ) - base ).toLocaleString( 'en' ) })`
            : 'Rigid 3T fork (included)'
        }));
      },
      hasColors() {
        return this.shown.length > 1;
      }
    },
    methods: {
      finishName( color ) {
        return color.forkOption ? color.colorName.replace( ` · ${ color.forkOption }`, '' ) : color.colorName;
      },
      selectFork( fork ) {
        const name = this.current && this.finishName( this.current );
        const options = this.colors
          .map(( color, index ) => ({ color, index }))
          .filter(({ color }) => ( color.forkOption || '' ) === fork );
        const match = options.find(({ color }) => this.finishName( color ) === name ) || options[ 0 ];
        if ( match ) this.$emit( 'input', match.index );
      }
    }
  }
</script>

<style lang="scss">
  .builder-info {
    position: relative;
  }
  .item-info {

    width: 50%;
    float: left;

    &.alone {
      width: 100%;
    }
  }
  .item-actions {
    clear: both;
  }
  .tyre-width, .fork-option { clear: both; }

  @media ( max-width: 600px ) {
    .builder-info {
      display: flex;
      flex-direction: column;
    }
    .item-info {
      float: none;
      width: 100%;
      order: 0;
      &.outline-left {
        border: 0 !important;
        order: 1;
        margin-top: 4px;
      }
    }
    .item-info .headline {
      font-size: 1.15rem !important;
      line-height: 1.35rem;
    }
    .item-actions {
      order: 2;
      margin-top: 4px !important;
    }
  }
</style>
